import React, {useLayoutEffect, useState} from "react";

const injectWindowSize =
  WrappedComponent =>
    props => {
      const [size, setSize] = useState({
        width: 0,
        height: 0,
        breakpointStep: "lg",
      });

      useLayoutEffect(() => {
        function getBreakpointStep () {
          switch (true) {
            case (window.innerWidth <= 575.98):
              return "xs";
            case (window.innerWidth >= 576 && window.innerWidth <= 767.98):
              return "sm";
            case (window.innerWidth >= 768 && window.innerWidth <= 991.98):
              return "md";
            case (window.innerWidth >= 992 && window.innerWidth <= 1199.98):
              return "lg";
            case (window.innerWidth >= 1200 && window.innerWidth <= 1599.98):
              return "xl";
            case (window.innerWidth >= 1600):
            default:
              return "xxl";
          }
        }

        function updateSize() {
          setSize({
            width: window.innerWidth,
            height: window.innerHeight,
            breakpointStep: getBreakpointStep(),
          });
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
      }, []);

      return (
        <WrappedComponent
          {...props}
          windowSize={size}
        />
      );
    };

export default injectWindowSize;